import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const Register = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="xl">
        {/* Register Section */}
        <Box
          sx={{
            mb: 8,

            borderRadius: "24px",
            paddingY: { xs: 4, md: 4 },
            paddingX: { xs: 4, md: 8 },

            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 4, md: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              justifyContent: "space-between",
              gap: { xs: 4, md: 4 },
              width: "100%",
              paddingX: { xs: 4, md: 6 },
              // marginX: { xs: 2, md: 5 },
              paddingY: { xs: 2, md: 14 },
              borderRadius: "28px",
              border: "2px solid #F7F1E8",
              backgroundColor: "#FFF9F0",
            }}
          >
            {/* Left Side - Mask Image */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                order: { xs: 2, md: 1 },
              }}
            >
              <Box
                component="img"
                src="/assets/mask.svg"
                alt="Himachal Pradesh Map"
                sx={{
                  width: "100%",
                  borderRadius: "22px",
                  mb: { xs: 4, md: 0 },
                  maxWidth: "500px",
                }}
              />
            </Box>

            {/* Right Side - Text and Button */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                textAlign: "left",
                mt: { xs: 4, md: 0 },
                gap: { xs: 3, md: 6 },
                order: { xs: 1, md: 2 },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "46px", md: "56px", lg: "64px" },
                  fontFamily: "Test Domaine Display, serif",
                  fontWeight: 700,
                  lineHeight: { xs: "1.1", md: "30px" },
                  color: "#000",
                  mb: { xs: 0, md: 3 },
                }}
              >
                Register Now!
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "24px", md: "32px", lg: "32px" },
                  justifyContent: { xs: "flex-start", md: "flex-start" },
                  color: "#333333",
                  fontWeight: 400,
                  fontFamily: "Elza, sans-serif",
                  lineHeight: { xs: "35.39px", md: 1.2 },
                  letterSpacing: "0px",
                  mb: { xs: 0, md: 4 },
                  maxWidth: { xs: "100%", md: "600px" },
                  opacity: 1,
                }}
              >
                Your application will be reviewed to identify your motivation,
                leadership potential, and ability to create impact.
              </Typography>

              <Button
                component={Link}
                to="/register"
                sx={{
                  background:
                    "linear-gradient(0deg, #333333, #333333), linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50.72%)",
                  color: "#fff",
                  textTransform: "none",
                  fontSize: { xs: "18px", md: "27px" },
                  fontWeight: 600,
                  width: { xs: "216.08px", md: "auto" },
                  height: { xs: "56.69px", md: "68px" },
                  borderRadius: { xs: "27.08px", md: "50px" },
                  paddingTop: { xs: "9.85px", md: 2 },
                  paddingRight: { xs: "29.54px", md: 5 },
                  paddingBottom: { xs: "9.85px", md: 2 },
                  paddingLeft: { xs: "29.54px", md: 5 },
                  gap: { xs: "12.31px", md: 0 },
                  opacity: 1,
                  boxShadow: {
                    xs: "0px 3.28px 19.69px 0px #33333320",
                    md: "0px 4px 24px 0px #33333320",
                  },
                  borderTop: {
                    xs: "2.46px solid #FFFFFF33",
                    md: "3px solid #FFFFFF33",
                  },
                  "&:hover": {
                    background:
                      "linear-gradient(0deg, #333333, #333333), linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50.72%)",
                    boxShadow: "0px 6px 28px 0px #33333330",
                  },
                }}
              >
                Register Now →
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Quote Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Mobile Quote Image - Display on xs and sm screens */}
          <Box
            component="img"
            src="/assets/mobilequote.png"
            alt="Swami Vivekananda Quote"
            sx={{
              width: "100%",
              maxWidth: "600px",
              height: "auto",
              display: { xs: "block", md: "none" },
            }}
          />

          {/* Desktop Quote Image - Display on md screens and above */}
          <Box
            component="img"
            src="/assets/quote.png"
            alt="Swami Vivekananda Quote"
            sx={{
              width: "100%",
              maxWidth: "1400px",
              height: "auto",
              display: { xs: "none", md: "block" },
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Register;
